import { Box } from "@mui/material";

const AuthContainer = ({ children }) => {
  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", m: "15vh 5px 5px 5px" }}
    >
      <Box
        sx={{
          // background: 'white',
          border: "1px solid #e0e0e0",
          borderRadius: 5,
          padding: "2rem",
          display: "grid",
          rowGap: 4,
          placeItems: "center",
          width: 500,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AuthContainer;
